import React from 'react';
import '../../assets/dsgov/css/components/avatar.css';

export default function Avatar(props) {
  return (
    <div className="br-avatar">
      <div className="image">
        <img src={props.image} alt={props.alt} />
      </div>
    </div>
  );
}
